import * as React from 'react'

import { cn } from '@/lib/utils'

interface Props
  extends Omit<React.ComponentProps<'textarea'>, 'value' | 'onChange'> {
  value: string

  onChange(value: string, evt: React.ChangeEvent<HTMLTextAreaElement>): void
}

function Textarea({
  className,

  value,
  onChange,

  ...props
}: Props) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex field-sizing-content w-full rounded-xl p-4',
        'bg-white border border-gray-200 text-neutral-700 text-lg transition-[color] outline-none',
        'placeholder:text-muted-foreground',
        'focus-visible:border-secondary',
        'disabled:cursor-not-allowed disabled:opacity-50 disabled:pointer-events-none disabled:text-neutral-400',
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
        className
      )}
      value={value}
      onChange={evt => onChange(evt.target.value, evt)}
      {...props}
    />
  )
}

export { Textarea }
